<form class="common-form" [formGroup]="form">
  <app-form>
    <app-row>
      <div class="status">
        <p-inputSwitch formControlName="isEnabled"></p-inputSwitch>
        <status [value]="!!form.value.isEnabled"></status>
      </div>
    </app-row>

    <app-row>
      <app-field [label]="'Шаблон' + (templateName ? ': ' + templateName : '')">
        <button
          pButton
          class="p-button-success"
          [label]="templateControl.value ? 'Изменить' : 'Выбрать или загрузить'"
          [size]="'small'"
          (click)="templatesVisible = true"
        ></button>

        <report-templates
          *ngIf="templatesVisible"
          [selectedItem]="templateControl.value"
          (accept)="selectedTemplateChange($event)"
          (reject)="templatesVisible = false"
        ></report-templates>
      </app-field>
    </app-row>

    <app-row>
      <app-field [label]="'Наименование отчёта'">
        <input
          pInputText
          type="text"
          formControlName="name"
          placeholder="Введите наименование отчёта"
          [class.loading]="loading"
        />
      </app-field>
    </app-row>

    <app-row>
      <app-field [label]="'Описание отчёта'">
        <textarea
          pInputTextarea
          [autoResize]="true"
          rows="2"
          formControlName="description"
          placeholder="Введите описание отчёта"
          [class.loading]="loading"
        ></textarea>
      </app-field>
    </app-row>

    <app-row>
      <app-field [label]="'Категории отчёта'">
        <p-multiSelect
          formControlName="categories"
          [options]="(categories$ | async) ?? []"
          optionLabel="label"
          optionValue="key"
          [display]="categoriesControlValue.length > maxSelectedCategories ? 'comma' : 'chip'"
          [maxSelectedLabels]="maxSelectedCategories"
          selectedItemsLabel="Выбрано {0} категорий"
          placeholder="Выберите категории"
          [showClear]="true"
          [filter]="false"
          [class.loading]="loading"
        />
      </app-field>
    </app-row>

    <app-row>
      <app-field [label]="'Форматы для формирования отчёта'">
        <p-multiSelect
          formControlName="formats"
          [options]="formats"
          [display]="formatsControlValue.length > maxSelectedFormats ? 'comma' : 'chip'"
          [maxSelectedLabels]="maxSelectedFormats"
          selectedItemsLabel="Выбрано {0} форматов"
          placeholder="Выберите форматы"
          [showClear]="true"
          [filter]="false"
          [class.loading]="loading"
        />
      </app-field>
    </app-row>
  </app-form>
</form>
